function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { dataURItoBlob, shouldRender } from "../utils";

function addNameToDataURL(dataURL, name) {
  return dataURL.replace(";base64", ";name=" + encodeURIComponent(name) + ";base64");
}

function processFile(file) {
  const name = file.name,
        size = file.size,
        type = file.type;
  return new Promise((resolve, reject) => {
    const reader = new window.FileReader();
    reader.onerror = reject;

    reader.onload = event => {
      resolve({
        dataURL: addNameToDataURL(event.target.result, name),
        name,
        size,
        type
      });
    };

    reader.readAsDataURL(file);
  });
}

function processFiles(files) {
  return Promise.all([].map.call(files, processFile));
}

function FilesInfo(props) {
  const filesInfo = props.filesInfo;

  if (filesInfo.length === 0) {
    return null;
  }

  return React.createElement("ul", {
    className: "file-info"
  }, filesInfo.map((fileInfo, key) => {
    const name = fileInfo.name,
          size = fileInfo.size,
          type = fileInfo.type;
    return React.createElement("li", {
      key: key
    }, React.createElement("strong", null, name), " (", type, ", ", size, " bytes)");
  }));
}

function extractFileInfo(dataURLs) {
  return dataURLs.filter(dataURL => typeof dataURL !== "undefined").map(dataURL => {
    const _dataURItoBlob = dataURItoBlob(dataURL),
          blob = _dataURItoBlob.blob,
          name = _dataURItoBlob.name;

    return {
      name: name,
      size: blob.size,
      type: blob.type
    };
  });
}

class FileWidget extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onChange", event => {
      const _this$props = this.props,
            multiple = _this$props.multiple,
            onChange = _this$props.onChange;
      processFiles(event.target.files).then(filesInfo => {
        const state = {
          values: filesInfo.map(fileInfo => fileInfo.dataURL),
          filesInfo
        };
        this.setState(state, () => {
          if (multiple) {
            onChange(state.values);
          } else {
            onChange(state.values[0]);
          }
        });
      });
    });

    const value = props.value;
    const values = Array.isArray(value) ? value : [value];
    this.state = {
      values,
      filesInfo: extractFileInfo(values)
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shouldRender(this, nextProps, nextState);
  }

  render() {
    const _this$props2 = this.props,
          multiple = _this$props2.multiple,
          id = _this$props2.id,
          readonly = _this$props2.readonly,
          disabled = _this$props2.disabled,
          autofocus = _this$props2.autofocus,
          options = _this$props2.options;
    const filesInfo = this.state.filesInfo;
    return React.createElement("div", null, React.createElement("p", null, React.createElement("input", {
      ref: _ref => this.inputRef = _ref,
      id: id,
      type: "file",
      disabled: readonly || disabled,
      onChange: this.onChange,
      defaultValue: "",
      autoFocus: autofocus,
      multiple: multiple,
      accept: options.accept
    })), React.createElement(FilesInfo, {
      filesInfo: filesInfo
    }));
  }

}

FileWidget.defaultProps = {
  autofocus: false
};

if (process.env.NODE_ENV !== "production") {
  FileWidget.propTypes = process.env.NODE_ENV !== "production" ? {
    multiple: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    autofocus: PropTypes.bool
  } : {};
}

export default FileWidget;